import React from "react";
import { Col, Space } from "antd";

import MediaList from "../../components/MediaList";

function SelledCarMediaManagement() {
    return (
        <div className="container">
            <Space size={30} direction="vertical" style={{ width: "100%" }}>
                <h3 className="title">미디어 관리</h3>
                <MediaList />
            </Space>
        </div>
    );
}

export default SelledCarMediaManagement;
